export default "__VITE_ASSET__bm73rff0__"